import React from "react";

import LoadingIndicator from "@cayuse/shared-react.components.loading-indicator";

import styles from "./styles.css";

const DownloadingModalContent = ({ text }) => {
	return (
		<div className={styles.downloadingContent}>
			<div className={styles.downloadingIndicatorWrapper}>
				<LoadingIndicator />
			</div>
			<p>{text}</p>
		</div>
	);
};

export default DownloadingModalContent;
